import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-edit-region-modal',
  templateUrl: './edit-region-modal.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./edit-region-modal.component.scss']
})
export class EditRegionModalComponent {
  public regionForm: FormGroup
  public isSuccess: boolean = false
  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditRegionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public regionData: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderInfoService: WellHeaderInfoService
  ) { }

  ngOnInit() {
    this.regionForm = this.initializeForm()
  }

  initializeForm() {
    return this.fb.group({
      id: this.regionData.regionId,
      companyId: this.regionData.operatorId,
      regionLongName: [this.regionData.name, [Validators.required, noWhitespaceValidator()]],
      regionShortName: [this.regionData.longName, [Validators.required, noWhitespaceValidator()]],
      remark: this.regionData.remarks,
    })
  }

  updateCompany() {
    this.isLoading = true

    this.wellHeaderInfoService.updatePsc(this.regionForm.value).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.isSuccess = true
          this.closeDialog()
        }

        this.isLoading = false
      },
      error: (e) => this.isLoading = false
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get regionLongName() {
    return this.regionForm.get('regionLongName');
  }

  get regionShortName() {
    return this.regionForm.get('regionShortName');
  }
}
